import React from "react";
import PropTypes from "prop-types";

import { Heading } from "../Heading";

import styles from "./CookieConsent.scss";

function CookieConsentHeadline({ children, ...otherProps }) {
  return (
    <Heading
      variants={[
        Heading.Variant.quaternary,
        Heading.Variant.highlight,
        styles["view-headline"],
      ]}
      {...otherProps}
    >
      {children}
    </Heading>
  );
}

CookieConsentHeadline.propTypes = {
  children: PropTypes.node.isRequired,
};

CookieConsentHeadline.displayName = "CookieConsent.Headline";

export default CookieConsentHeadline;
